export const LeadsDetailsTableHeader = [
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
  },
  {
    field: 'phone',
    headerName: 'Phone Number',
    width: 200,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 200,
  },
  {
    field: 'timestamp',
    headerName: 'Created Date',
    width: 180,
    renderCell: (row) => {
      return row.timestamp ? new Date(row.timestamp).toLocaleString() : '-';
    },
  },
  {
    field: 'source',
    headerName: 'Source',
    width: 200,
  },
  {
    field: 'ownerName',
    headerName: 'OGA',
    width: 200,
  },
  {
    field: 'isConverted',
    headerName: 'Converted',
    width: 150,
    renderCell: (row) => (row.isConverted ? 'Success' : 'Failed'),
  },
  {
    field: 'totalEnrollments',
    headerName: 'Total Enrollments',
    width: 200,
  },
  {
    field: 'conversionDate',
    headerName: 'Conversion Date',
    width: 200,
  },
  {
    field: 'courseName',
    headerName: 'Course Name',
    width: 200,
  },
  {
    field: 'daysToEnroll',
    headerName: 'Days To Enroll',
    width: 200,
  },
];
